import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import AdminLayout from "@/components/AdminLayout";

export default function AdminGuard({ children }) {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (loading) return;
    if (!user) {
      navigate("/login?next=/admin");
    } else if (user.role !== "admin") {
      navigate("/");
    }
  }, [user, loading, navigate]);

  if (loading || !user || user.role !== "admin") {
    return (
      <div className="min-h-screen flex items-center justify-center text-[#4A5568] text-sm">
        Checking access...
      </div>
    );
  }

  return <AdminLayout>{children}</AdminLayout>;
}
